import { Compass, Scale, NotebookPen, Library, CircleUser } from "lucide-react";

export const NAV = [
  { key: "attention", to: "/", icon: Compass, labelKey: "nav.attention", end: true },
  { key: "decisions", to: "/keputusan", icon: Scale, labelKey: "nav.decisions" },
  { key: "sheet", to: "/lembar", icon: NotebookPen, labelKey: "nav.sheet" },
  { key: "library", to: "/library", icon: Library, labelKey: "nav.library" },
  { key: "account", to: "/akun", icon: CircleUser, labelKey: "nav.account" },
];
